import * as __au2ViewDef from './summary-panel.html';
import { customElement } from 'aurelia';
import { watch } from '@aurelia/runtime-html';
import { IAppService } from '../../../services/app';

import ArrowDown from '../../../assets/icons/arrow-down.png';

@customElement({ ...__au2ViewDef, name: 'summary-panel' })
export class SummaryPanel {
    protected arrowDown = ArrowDown;

    private adviser;
    private adviserContact;
    private phone;
    private email;

    constructor(@IAppService readonly appService: IAppService) {}

    attached() {
        this.adviserChanged();
    }

    @watch((model: SummaryPanel) => model.appService.scheme.adviser)
    adviserChanged() {
        this.adviser = this.appService.scheme?.adviser?.adviser;
        this.adviserContact = this.appService.scheme?.adviser?.adviserContact;

        const phone = this.adviserContact?.[0]?.phoneNumber;
        const newPhone = [];

        if (phone?.length === 10) {
            newPhone.push(phone.slice(0, 4));
            newPhone.push(phone.slice(4, 7));
            newPhone.push(phone.slice(7));

            this.phone = newPhone.join(' ');
        } else if (phone?.length === 8) {
            newPhone.push(phone.slice(0, 4));
            newPhone.push(phone.slice(4));

            this.phone = newPhone.join(' ');
        }

        this.email = this.adviserContact?.[1]?.email;
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = SummaryPanel;

    // @ts-ignore
    const proto = SummaryPanel.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }